export const SIM_COLUMN_TYPES = ["string", "int", "file"];
export const SIM_TYPE_STATUSES = ["active", "deprecated"];

export const SIM_TYPE_FORM_EMPTY = {
  name: "",
  dataPlan: "",
  roaming: false,
  status: "active",
  columns: [],
};

export function simTypeToForm(simType) {
  if (!simType) return { ...SIM_TYPE_FORM_EMPTY, columns: [] };
  return {
    name: simType.name ?? "",
    dataPlan: simType.dataPlan ?? "",
    roaming: Boolean(simType.roaming),
    status: SIM_TYPE_STATUSES.includes(simType.status) ? simType.status : "active",
    columns: (simType.columns ?? []).map((col) => ({ key: col.key ?? "", type: col.type ?? "string" })),
  };
}

export function validateSimTypeForm(form) {
  const errors = {};
  if (!form.name?.trim()) errors.name = "SIM type name is required";
  if (!form.dataPlan?.trim()) errors.dataPlan = "Data plan is required";
  if (!SIM_TYPE_STATUSES.includes(form.status)) errors.status = "Select a status";

  const columnErrors = [];
  const seenKeys = new Set();
  (form.columns ?? []).forEach((col, index) => {
    const key = col.key?.trim();
    const row = {};
    if (!key) row.key = "Key is required";
    else if (seenKeys.has(key.toLowerCase())) row.key = "Duplicate key";
    else seenKeys.add(key.toLowerCase());
    if (!SIM_COLUMN_TYPES.includes(col.type)) row.type = "Select a type";
    if (Object.keys(row).length) columnErrors[index] = row;
  });
  if (columnErrors.some(Boolean)) errors.columns = columnErrors;

  return errors;
}

export function simTypeFormToPayload(form) {
  return {
    name: form.name.trim(),
    dataPlan: form.dataPlan.trim(),
    roaming: Boolean(form.roaming),
    status: form.status,
    columns: (form.columns ?? [])
      .map((col) => ({ key: col.key.trim(), type: col.type }))
      .filter((col) => col.key),
  };
}
